// 覆盖现有 quantity-input 的点击方法，添加2秒节流
(function() {
  // 等待 DOM 加载完成
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantityThrottle);
  } else {
    initQuantityThrottle();
  }
  
  function initQuantityThrottle() {
    const QuantityInputClass = customElements.get('quantity-input');
    
    if (!QuantityInputClass) {
      console.error('未找到 quantity-input 组件');
      return;
    }
    
    console.log('正在为 quantity-input 添加节流控制...');
    
    // 保存原始的 onButtonClick 方法
    const originalOnButtonClick = QuantityInputClass.prototype.onButtonClick;
    
    // 覆盖 onButtonClick 方法
    QuantityInputClass.prototype.onButtonClick = function(event) {
      event.preventDefault();
      
      // 检查是否在冷却期
      if (this._isUpdating) {
        console.log('请等待2秒后再次操作');
        
        // 添加视觉反馈
        const button = event.currentTarget;
        button.style.transform = 'scale(0.9)';
        setTimeout(() => {
          button.style.transform = '';
        }, 150);
        
        return;
      }
      
      // 获取当前值
      const input = this.input || this.querySelector('input');
      if (!input) return;
      
      const previousValue = input.value;
      const button = event.currentTarget;
      
      // 执行原始的加减逻辑
      if (button.name === 'plus') {
        input.stepUp();
      } else {
        input.stepDown();
      }
      
      // 检查值是否改变
      if (previousValue !== input.value) {
        // 启动冷却期
        this._isUpdating = true;
        
        // 禁用所有数量按钮
        const allButtons = this.querySelectorAll('button');
        allButtons.forEach(btn => {
          btn.setAttribute('disabled', 'disabled');
          btn.style.opacity = '0.5';
        });
        
        console.log('数量更新中，2秒内无法再次操作');
        
        // 触发 change 事件
        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);
        
        // 2秒后重新启用
        setTimeout(() => {
          allButtons.forEach(btn => {
            // 检查是否应该保持禁用状态（比如已达到最小/最大值）
            const shouldStayDisabled = 
              (btn.name === 'minus' && parseInt(input.value) <= parseInt(input.min || 0)) ||
              (btn.name === 'plus' && input.max && parseInt(input.value) >= parseInt(input.max));
            
            if (!shouldStayDisabled) {
              btn.removeAttribute('disabled');
              btn.style.opacity = '';
            }
          });
          this._isUpdating = false;
          console.log('可以再次操作了');
        }, 2000);
      } else {
        // 值没有改变（可能已达到最小/最大值）
        console.log('数量未改变');
      }
    };
    
    console.log('✓ quantity-input 节流控制已应用（2秒冷却）');
  }
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this._boundHandleDocumentKeyDown = this._handleDocumentKeyDown.bind(this);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    }, 30);
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (typeof trapFocus === 'function') {
        trapFocus(containerToTrapFocusOn, focusElement);
      }
    }, { once: true });
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this._boundHandleDocumentKeyDown);
  }

  close() {
    if (!this.classList.contains('active')) return;
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function' && this.activeElement) {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this._boundHandleDocumentKeyDown);
  }

  _handleDocumentKeyDown(event) {
    if (event.code === 'Escape') {
      if (this.classList.contains('active')) {
        const isModalDrawerOpen = document.querySelector('modal-drawer[open]');
        if (isModalDrawerOpen) {
          return;
        }
        event.preventDefault();
        this.close();
      }
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (typeof onKeyUpEscape === 'function') {
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.removeEventListener('click', this.close.bind(this));
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    }, 50);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// 优化 cart-remove-button，防止 429 错误
if (!customElements.get('cart-remove-button')) {
  customElements.define(
    'cart-remove-button',
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.isRemoving = false;
        
        this.addEventListener('click', (event) => {
          event.preventDefault();
          
          if (this.isRemoving) {
            console.log('Deletion request in progress, please wait...');
            return;
          }
          
          const button = event.target.closest('button');
          if (!button) return;
          
          this.isRemoving = true;
          button.setAttribute('disabled', 'disabled');
          button.classList.add('loading');
          
          const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
          const index = this.dataset.index;
          
          this.removeItem(cartItems, index, button);
        });
      }
      
      removeItem(cartItems, index, button) {
        const body = JSON.stringify({
          line: index,
          quantity: 0,
          sections: cartItems.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: body
        })
        .then((response) => {
          if (response.status === 429) {
            throw new Error('The operation is too frequent, please try again later.');
          }
          if (!response.ok) {
            throw new Error(`Delete failed (${response.status})`);
          }
          return response.json();
        })
        .then((state) => {
          if (state.errors) {
            throw new Error(state.errors);
          }
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-remove-button',
              cartData: state
            });
          }
          if (cartItems && typeof cartItems.renderContents === 'function') {
            cartItems.renderContents(state);
          }
        })
        .catch((error) => {
          console.error('Delete product error:', error);
          button.removeAttribute('disabled');
          button.classList.remove('loading');
          this.isRemoving = false;
        })
        .finally(() => {
          setTimeout(() => {
            if (button.hasAttribute('disabled')) {
              button.removeAttribute('disabled');
              button.classList.remove('loading');
            }
            this.isRemoving = false;
          }, 1000);
        });
      }
    }
  );
}

